// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groups {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.groups p {
  border: 2px solid #d5d5d5;
  border-radius: 0;
  font-weight: 700;
  text-transform: uppercase;
  padding: 8px 28px;
  font-size: 0.875rem;
  color: #5c0a31;
  cursor: pointer;
}
.groups p.selected {
  background-color: #d5d5d5;
  color: #efefef;
}`, "",{"version":3,"sources":["webpack://./src/app/content/modules/storyblok/components/storyblok-group/storyblok-group.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;AACE;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACE,yBAAA;EACA,cAAA;AACN","sourcesContent":[".groups {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n\n  p {\n    border: 2px solid #d5d5d5;\n    border-radius: 0;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding: 8px 28px;\n    font-size: .875rem;\n    color: #5c0a31;\n    cursor: pointer;\n\n    &.selected {\n      background-color: #d5d5d5;\n      color: #efefef;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
